export const mdrQueryKeys = {
    all: ['mdr'] as const,
    cases: (accountId: string, isMock: boolean) =>
        ['mdr', 'cases', accountId, isMock] as const,
    casesPage: (accountId: string, isMock: boolean, page: number) =>
        ['mdr', 'cases', accountId, isMock, page] as const,
}
